import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../Contexts/authContext';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';
import UserProfile from './UserProfile';
import './Header.css';
import '../styles/BetaIndicator.css';

const Header = () => {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Handle scroll to hide/show header
  const handleScroll = () => {
    // Always show header if user is not logged in (user request)
    if (!user) {
      if (!isVisible) setIsVisible(true);
      return;
    }

    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY && currentScrollY > 100) {
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }

    setLastScrollY(currentScrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY, user, isVisible]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isVisible ? '' : 'hidden'}`}>
      <div className="header-container">
        <div className="logo">
          <Link to="/" onClick={closeMobileMenu}>
            <img
              src="/images/logoMyCoachServer.png"
              alt="MyCoachServer Logo"
              className="logoTitle"
              width="200"
              height="55"
              fetchPriority="high"
            />
            <span className="beta-badge">{t('common.betaMode')}</span>
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="nav-links desktop-nav">
          <ul>
            <li><Link to="/">{t('header.home')}</Link></li>
            <li><Link to="/sports">{t('header.sports')}</Link></li>
            <li><Link to="/features">{t('header.features')}</Link></li>
            <li><Link to="/contact">{t('header.contact')}</Link></li>
            <li><Link to="/pricing">{t('header.pricing')}</Link></li>
          </ul>
        </nav>

        {/* Desktop Auth Links */}
        <div className="auth-links desktop-auth">
          <LanguageSelector />
          {user ? (
            <>
              <UserProfile />
              <button
                className="btn-logout"
                onClick={() => {
                  if (window.confirm(t('header.logoutConfirm') || 'Tem certeza que deseja sair?')) {
                    logout();
                  }
                }}
              >
                <i className="fas fa-sign-out-alt"></i> {t('header.logout')}
              </button>
            </>
          ) : (
            <>
              <Link to="/login"><button className="btn-login">{t('header.login')}</button></Link>
              <Link to="/register"><button className="btn-register">{t('header.register')}</button></Link>
            </>
          )}
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <nav className="mobile-nav">
          <ul>
            <li><Link to="/" onClick={closeMobileMenu}>{t('header.home')}</Link></li>
            <li><Link to="/sports" onClick={closeMobileMenu}>{t('header.sports')}</Link></li>
            <li><Link to="/features" onClick={closeMobileMenu}>{t('header.features')}</Link></li>
            <li><Link to="/contact" onClick={closeMobileMenu}>{t('header.contact')}</Link></li>
            <li><Link to="/pricing" onClick={closeMobileMenu}>{t('header.pricing')}</Link></li>
          </ul>
        </nav>
        <div className="mobile-auth">
          <div style={{ marginBottom: '15px' }}>
            <LanguageSelector />
          </div>
          {user ? (
            <>
              <UserProfile />
              <button
                className="btn-logout mobile-logout"
                onClick={() => {
                  if (window.confirm(t('header.logoutConfirm') || 'Tem certeza que deseja sair?')) {
                    closeMobileMenu();
                    logout();
                  }
                }}
                style={{ marginTop: '10px', width: '100%', justifyContent: 'center' }}
              >
                <i className="fas fa-sign-out-alt"></i> {t('header.logout')}
              </button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={closeMobileMenu}><button className="btn-login">{t('header.login')}</button></Link>
              <Link to="/register" onClick={closeMobileMenu}><button className="btn-register">{t('header.register')}</button></Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;